import { useIntl } from "react-intl";

import { ListToggleButton } from "@/components/ListToggleButton/ListToggleButton";
import { ToggleButtonGroup } from "@/components/ToggleButtonGroup/ToggleButtonGroup";
import { StopsOptions } from "@/features/flights/types/types";

type Props = {
  value?: StopsOptions;
  onChange: (newValue: StopsOptions) => void;
};

export function StopsFilter({ value, onChange }: Props) {
  const intl = useIntl();

  return (
    <ToggleButtonGroup
      orientation="vertical"
      size="small"
      color="primary"
      fullWidth
    >
      <ListToggleButton
        value={StopsOptions.ANY}
        selectionVariant="radio"
        selected={value === StopsOptions.ANY}
        onChange={(_e, newValue) => onChange(newValue as StopsOptions)}
      >
        {intl.formatMessage({
          defaultMessage: "Any",
          description: "Filter option: any number of stops (no preference)",
        })}
      </ListToggleButton>
      <ListToggleButton
        value={StopsOptions.DIRECT}
        selectionVariant="radio"
        selected={value === StopsOptions.DIRECT}
        onChange={(_e, newValue) => onChange(newValue as StopsOptions)}
      >
        {intl.formatMessage({
          defaultMessage: "Direct",
          description: "Filter option: direct / non-stop flights only",
        })}
      </ListToggleButton>
      <ListToggleButton
        value={StopsOptions.ONE}
        selectionVariant="radio"
        selected={value === StopsOptions.ONE}
        onChange={(_e, newValue) => onChange(newValue as StopsOptions)}
      >
        {intl.formatMessage({
          defaultMessage: "Up to 1",
          description: "Filter option: up to one stop",
        })}
      </ListToggleButton>
    </ToggleButtonGroup>
  );
}
